<template>
<div id="app">
  <router-view class="top-router-view"/>
  <footer>
    <div class="footer-view">
      <p>© Network Co.,Ltd.</p>
    </div>
  </footer>
</div>
</template>

<script>
import "purecss"

export default {
  mounted() {
    if (process.env.NODE_ENV == "production") {
      // 「router-path」にvue内でのパスを入れてあるので、それをもとに遷移しておく
      // 更新ボタンが押された時や、ブックマークから開かれた時にトップページが表示されてしまうのを防ぐため
      let path = document.getElementById("router-path").value
      path = path.replace("/admin", "")
      if (path != "") {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-y: hidden;
}

.top-router-view {
  height: 100%;
}

footer {
  width: 100%;
  background: linear-gradient(90deg, lavenderblush, #83ccd2);
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.footer-view {
  width: 100%;
  padding: 5px;

  p {
    color: black;
    font-size: 12px;
    text-align: right;
    vertical-align: top;
    margin: 0px;
    margin-right: 20px;
  }
}
</style>

<style lang="scss">

/* フォント */
html {
  font-size: 100px; // 1rem = 100pxと定義
}

body {
  font-size: 0.16rem; // 100px * 0.16rem = 16px
}

h1 {
  font-size: 0.3rem;
}

h2 {
  font-size: 0.25rem;
}

@media screen and (max-width: 420px) {
  html {
    font-size: 50px; // 1rem = 50pxと定義
  }

  body {
    font-size: 0.28rem; // 50px * 0.28rem = 14px
  }

  h1 {
    font-size: 0.4rem;
  }

  h2 {
    font-size: 0.35rem;
  }
}


html, body {
  height: 100%;
}

body {
  margin: 0;
}

.main-content {
  display: inline;
  vertical-align: middle;
}

.box {
  display: inline-block;
}

.get-start-pre-form {
  margin: auto;
  display: inline-block;
}

.content-block {
  width: calc(100% - 150px);
  height: 100%;
  vertical-align: top;
}

.content {
  width: 100%;
  height: 100%;
  text-align: center;

  div {
    margin: 0 auto;
  }

  .nest-contents {
    margin: 10px;
  }
}

.contents {
  width: 100%;
  text-align: center;
}

.input-area {
  padding: 16px;
  width: 600px;

  button {
    display: inline-block;
    margin-top: 10px;
    margin-left: auto;
  }
}

.err-message {
  text-align: center;
  color: #dc143c;
  font-size: 12px;
}

.fieldset {
  text-align: left;
  width: 350px;
  margin: auto;
  margin-bottom: 10px !important;

  label {
    margin-top: 10px; 
  }

  #email-input {
    width: 100%;
  }
}

table {
  height: 100%;
  width: 100%;

  thead {
    width: auto;
    display: block;
  }

  tbody {
    display: block;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  tr {
    width: 100%;
    display: table;
  }

  td {
    text-align: center;
    vertical-align: middle;
    word-break: break-all;
  }
}

.pure-menu-link:hover {
  background-color: #FFF;
}

@media screen and (max-width: 420px) {
  table {
    thead {
      width: auto;
    }
  }
  .get-start-pre-form {
    width: 100%;
  }

  .fieldset {
    width: 95%;
  }

  .content-block {
    width: 100%;
  }

  .contents {
    width: 90%;
    margin: auto;
  }
}
</style>
